import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';

import EventsWrapperV1 from './v1';
import EventsWrapperV2 from './v2';

const EventsWrapper = (props) => {
  const { flagEvEventsLazyloadGroupHome } = useFeatureFlag();

  if (flagEvEventsLazyloadGroupHome) {
    return <EventsWrapperV2 {...props} />;
  }

  return <EventsWrapperV1 {...props} />;
};

export default EventsWrapper;
